/**
 * Simple function to toggle items.
 *
 * @param {string} event Allows emitting livewire events when calling the dropdown.
 * @param {bool} show Initialize the dropdown as open?
 */
export default function (event = null, show = false) {
    return {
        debounce: null,
        show: show,
        event: event,
        emit: function (event, value) {
            if (!this.event) {
                return;
            }

            if (this.debounce) {
                clearTimeout(this.debounce);
            }

            this.debounce = setTimeout(() => {
                window.livewire.emit(event, value);
            }, 500);
        },
        close: function () {
            this.show = false;

            this.emit(this.event + '@close');
        },
        open: function () {
            this.show = true;

            this.emit(this.event + '@show');
        },
        toggle: function () {
            this.show = !this.show;
            if (this.show) {
                this.emit(this.event + '@show');

                return;
            }

            this.emit(this.event + '@hide');
        },
        isOpen: function () {
            return this.show == true;
        },
    };
}
